import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type Method = {
  customerUUID: string;
  guid: string;
};

export type PatchUserPayoutMethods = (
  userId: number,
  data: { methods: Method[] },
) => Promise<{ status: number }>;

export default (makeCall: MakeCall): PatchUserPayoutMethods =>
  (userId, data) =>
    makeCall('PATCH', `/user/${userId}/payout-methods`, { data });
